import api from '../api';

import { ParamsDataUserAccountPassword } from 'utils/typeServices';

type ParamsResponse = {
    Data: ParamsDataUserAccountPassword;
}

export const PostValidateEmailLogin = async ({ body }: { body: string }) => {
    const bodyJson = JSON.stringify({ email: body });
    const bodyJsonContacts = JSON.stringify({ login: body, document: "" });

    try {
        const { data } = await api.post<{ Data: boolean }>('/v1/Cliente/ValidateEmailLogin', bodyJson);

        if (data.Data) {
            const { data: dataGetContacts } = await api.post<ParamsResponse>('/v1/Cliente/GetContacts', bodyJsonContacts);

            return { data: dataGetContacts.Data };
        }

        return { data: null };
    } catch (error) {
        console.error('error', error);
        return { data: null };
    }
}
